import { render, staticRenderFns } from "./AdminAreaBranchDetailTabImportModal.vue?vue&type=template&id=9af71060&scoped=true&"
import script from "./AdminAreaBranchDetailTabImportModal.vue?vue&type=script&lang=js&"
export * from "./AdminAreaBranchDetailTabImportModal.vue?vue&type=script&lang=js&"
import style0 from "./AdminAreaBranchDetailTabImportModal.vue?vue&type=style&index=0&id=9af71060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af71060",
  null
  
)

export default component.exports